// extracted by mini-css-extract-plugin
export default {"guide_section":"guide_guide_section__37pt3","guide_section_box":"guide_guide_section_box__p4wlU","step_box":"guide_step_box__QoCJf"};